// Third-party packages
import {
	MediaType,
} from '@@types/Media';
import {
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';

export interface OfferEntryMediaState {
	media: MediaType[] | undefined;
	isError: boolean;
	isLoading: boolean;
}

export interface OffersEntryMediaStore {
	[offerId: number]: OfferEntryMediaState;
}

const initialState: OffersEntryMediaStore = {};

export const offersEntryMediaSlice = createSlice({
	initialState,
	name: 'offers_entry_media',
	reducers: {
		clearOfferEntryMedia: (state, action: PayloadAction<number>) => {
			const offerId = action.payload;
			delete state[offerId];
		},
		setOfferEntryMedia: (state, action: PayloadAction<{
			media: MediaType[] | undefined;
			offerId: number;
		}>) => {
			const {
				media,
				offerId,
			} = action.payload;
			if (!state[offerId]) {
				state[offerId] = {
					isError: false,
					isLoading: false,
					media: undefined,
				};
			}
			state[offerId].media = media;
		},
		setOfferEntryMediaError: (state, action: PayloadAction<{
			isError: boolean;
			offerId: number;
		}>) => {
			const {
				isError,
				offerId,
			} = action.payload;
			if (!state[offerId]) {
				state[offerId] = {
					isError: false,
					isLoading: false,
					media: undefined,
				};
			}
			state[offerId].isError = isError;
		},
		setOfferEntryMediaLoading: (state, action: PayloadAction<{
			isLoading: boolean;
			offerId: number;
		}>) => {
			const {
				isLoading,
				offerId,
			} = action.payload;
			if (!state[offerId]) {
				state[offerId] = {
					isError: false,
					isLoading: false,
					media: undefined,
				};
			}
			state[offerId].isLoading = isLoading;
		},
	},
});

export const {
	clearOfferEntryMedia,
	setOfferEntryMedia,
	setOfferEntryMediaError,
	setOfferEntryMediaLoading,
} = offersEntryMediaSlice.actions;

export const offersEntryMediaReducer = offersEntryMediaSlice.reducer;


